module.exports = __webpack_public_path__ + "img/check_mark.562db446.png";